import { useCallback, useEffect, useState } from 'react';
import type { HomeScreenStatus, TelegramApi } from '../../telegram/webapp';

/** Shortcut status, re-read after the resident returns from Telegram's dialog. */
export function useHomeScreen(telegram: TelegramApi) {
  const [status, setStatus] = useState<HomeScreenStatus>('unsupported');
  const refresh = useCallback(() => {
    void telegram.homeScreen.status().then(setStatus);
  }, [telegram]);
  useEffect(() => {
    refresh();
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refresh]);
  // Telegram cannot tell 'unknown' from 'missed' on some clients; offering the dialog is harmless in both cases.
  const canAdd = status === 'missed' || status === 'unknown';
  return { canAdd, add: () => telegram.homeScreen.add() };
}
